/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require 'v4/boq_editor/editor_utils'
//= require 'v4/boq_document_version'

window.BoqEditor = {
  _autoSaveInterval: null,

  _parseSaveResponse(message) {
    const jsonResponse = JSON.parse(message);
    const flashMessage = this._getFlashContainer();
    flashMessage.show();

    BoqTree.clearErrors();

    if (jsonResponse.errors) {
      flashMessage.attr('class', 'alert-box alert');
      flashMessage.html(I18n.t("errors.0004") + '<a href="javascript:;" class="close">&times;</a>');

      _.each(jsonResponse.errors, (value, key) => BoqTree.markErrors({ rowId: key, errors: value }));
      return false;
    }

    flashMessage.attr('class', 'alert-box success');
    flashMessage.html(I18n.t("flash.bid_item.save.successfully") + '<a href="javascript:;" class="close">&times;</a>');
    this._flashTimeOut();
    return true;
  },

  _clickSaveButton() {
    const saveStatus = this._sendEditorDataToSave(
      {
        "new_items": BoqTree._getMappedNewOrModifiedNodes(),
        "delete_items": BoqTree._getMappedDeletedNodes()
      },
      $('#boq_items_save_url_').val()
    );

    if (saveStatus[1].success) {
      _.each(saveStatus[1].success, function (value, key) {
        const node = BoqTree._gridOptions.api.getRowNode(key);

        if (node) {
          node.data.id = value;
          return BoqTree._gridOptions.api.redrawRows({ rowNodes: [node] });
        }
      });
    }

    if (saveStatus[0]) {
      BoqTree._clearNewOrModifiedNodes();
      BoqTree._clearDeletedNodes();
    }

    if (saveStatus[1]['call_bid_link'] !== '') {
      $("#call_for_bid_wizard a").attr('href', saveStatus[1]['call_bid_link']);
      $("#call_for_bid_wizard a").removeAttr('disabled');
      $("#call_for_bid_wizard a").removeAttr('class');
    }

    return $.rails.enableElement($('#save'));
  },

  _setupSaveButton() {
    return $('.expand-list-top').on('click', '#save', event => {
      BoqTree._gridOptions.api.stopEditing();
      event.preventDefault();
      const openIssuesPresent = $('.issue[data-state=open]').length > 0;

      if (openIssuesPresent) {
        this._showUpdateIssuesModal();
        return this._setupUpdateIssuesForm();
      } else {
        return this._submitItems();
      }
    });
  },

  _showUpdateIssuesModal() {
    return $('#issuesModal').foundation('reveal', 'open', {
      url: $('#save').data('edit-issues-url')
    });
  },

  _setupUpdateIssuesForm() {
    return $(document).on('ajax:success', '#issues-report', (event, data, status, xhr) => {
      this._refreshIssues(data.updated_issues);
      $('#issuesModal').foundation('reveal', 'close');
      return this._submitItems();
    });
  },

  _submitItems() {
    $('#save').addClass('disabled');
    return setTimeout(_.bind(this._clickSaveButton, this), 100);
  },

  _refreshIssues(updatedIssues) {
    return $(document).trigger('update_issues_states', [updatedIssues]);
  },

  _resize() {
    return setTimeout(() => {
      return BoqTree._gridOptions.api.sizeColumnsToFit();
    });
  },

  initialize() {
    this._resize();
    $(window).resize(() => this._resize());
    $('.collapse-sidebar').click(() => this._resize());

    if ($("#page_boq_document_versions").length > 0) {
      if (typeof BOQ_EDITOR_VIEW === 'undefined') { return; }
      this._setupSaveButton();
      this._setupAutoSave();
      return $(document).on('childNodesLoaded', function (event, parentNode) {
        window.scrollToBody.initialize();
        return window.stickySidebar.initialize();
      });
    }
  },

  showImportModal() {
    return $('#import-modal').foundation('reveal', 'open');
  },

  _autoSave() {
    if ($('#auto_save').first().is(':checked')) {
      BoqTree._gridOptions.api.stopEditing();
      return this._clickSaveButton();
    }
  }
};

if (window.EditorUtils) _.extend(BoqEditor, window.EditorUtils);

window.boq = {};

const check_import = function (boq_document_version_id) {
  window.boq['id'] = boq_document_version_id;
  return setInterval((() => $.get('/boq/check_import.js', window.boq)), 30000);
};
